import { render } from "./DriveCreateCase.vue?vue&type=template&id=1b1c6ed5&scoped=true&ts=true"
import script from "./DriveCreateCase.vue?vue&type=script&lang=ts"
export * from "./DriveCreateCase.vue?vue&type=script&lang=ts"

import "./DriveCreateCase.vue?vue&type=style&index=0&id=1b1c6ed5&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b1c6ed5"]])

export default __exports__